var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityAccessibleToilet = function SvgAccessibilityAccessibleToilet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 21.065,
    cy: 18.222,
    r: 1.178
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m18.944 25.33-.746-.039c-.04.079-.982 2.2-1.1 2.435-.055.217-.18.41-.353.55a.42.42 0 0 1-.315.078.585.585 0 0 1-.432-.707c.393-1.178.786-2.395 1.179-3.573.039-.118.117-.158.235-.197.746-.078 1.414-.157 2.2-.196l1.06-3.22c.463.155.973.082 1.374-.197a5.64 5.64 0 0 1 1.493 2.082 2.91 2.91 0 0 1-.079 2.552q-.18.375-.432.707c-.157.197-.235.393-.471.471a.499.499 0 0 1-.668-.55c.08-.303.228-.585.432-.824.158-.284.277-.588.354-.903.078-.393-.236-.982-.275-1.14l-.314 1.061m-.786 5.616a2.84 2.84 0 0 0 3.024-2.592 2.62 2.62 0 0 0-.707-2.081"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M22.478 23.877a2.5 2.5 0 0 0-.746-.157 2.816 2.816 0 1 0-.432 5.616"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    d: "m6.92 5.851.078 9.308c.002.237.194.43.432.432h.275a.436.436 0 0 0 .432-.432l.353-4.674H9l.354 4.674c.002.237.195.43.432.432h.275a.436.436 0 0 0 .432-.432l.04-9.347"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8.883.628a1.107 1.107 0 1 0 .55.196.8.8 0 0 0-.55-.196m1.767 9.425s1.1.118 1.1-1.217V5.223c0-1.218-1.06-1.14-1.06-1.14H6.84s-1.06-.078-1.06 1.14v3.613c0 1.335 1.1 1.217 1.1 1.217"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    d: "m17.923 11.192 1.257-5.34m4.712 5.379-1.256-5.38"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M20.986.628a1.107 1.107 0 1 0 .55.196.94.94 0 0 0-.55-.196m.196 14.492-.274-3.928-.275 3.927a.436.436 0 0 1-.432.432h-.157a.436.436 0 0 1-.432-.432l-.158-3.888"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m20.633 15.12.275-3.928.274 3.927c.003.238.195.43.432.432h.158a.436.436 0 0 0 .432-.432l.157-3.888m-2.711.092h-1.727"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m22.164 11.31 1.728.065v-.065m-.275-1.964c.275-.078.864-.392.668-1.374-.118-.707-.471-2.16-.707-3.338a.92.92 0 0 0-.903-.747H19.18a.92.92 0 0 0-.904.747c-.235 1.178-.589 2.63-.707 3.338-.196.982.393 1.296.668 1.374"
  })), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8.425 21.207v3.063m.982-3.063v3.063m1.597-3.063H6.527a.55.55 0 0 1-.55-.472l-.314-2.16a.546.546 0 0 1 .55-.589h5.105a.546.546 0 0 1 .55.59l-.354 2.16a.51.51 0 0 1-.51.47zm-5.184-1.99h5.93m-2.2 10.158c0-.628.276-1.963.668-2.395q.384-.324.707-.707c.234-.348.357-.759.354-1.178H6.29c.01.423.147.833.393 1.178.196.275.471.432.707.707.432.471.707 1.767.667 2.395"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M11.279 25.134v-.51a.34.34 0 0 0-.314-.315H6.566a.34.34 0 0 0-.314.314v.51"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    d: "M10.847 20.238h1.492"
  }))));
};
export default SvgAccessibilityAccessibleToilet;